import styled from 'styled-components';

export const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const ModalTitle = styled.p`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	margin-bottom: 8px;
	text-align: center;
`;

interface ModalSubtitleProp {
	align?: 'start' | 'center' | 'end';
}

export const ModalSubtitle = styled.div<ModalSubtitleProp>`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 22px;
	margin-bottom: 8px;
	text-align: ${({ align }) => (align == 'center' ? 'center' : 'left')};

	a {
		color: ${({ theme }) => theme.colors.extra.earth};
		text-decoration: underline;
	}
`;

export const List = styled.ul`
	font-weight: 200;
	list-style-type: disc;
	margin: 16px auto;
	padding-left: 16px;
`;

export const ListItem = styled.li`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 16px;
	font-weight: 400;
	line-height: 22px;
	text-align: left;
`;

export const ListItemStrong = styled.strong`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 16px;
	font-weight: 600;
	line-height: 22px;
	text-align: left;
`;

export const ModalStep = styled.p`
	color: #140f33;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	letter-spacing: 0.6px;
	line-height: 12px;
	margin-bottom: 2px;
	text-align: center;
`;

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-top: 24px;
`;

interface HintInputProp {
	error?: boolean;
}

export const HintInput = styled.p<HintInputProp>`
	color: ${({ theme, error }) => (error ? '#FF433E' : theme.colors.principal.moon)};
	font-size: 12px;
	font-weight: 400;
	line-height: 12px;
	margin-top: 6px;
	width: 100%;
`;

export const ButtonContainer = styled.div`
	display: flex;
	gap: 16px;
`;

interface ButtonProp {
	outboundColor?: boolean;
}

export const Button = styled.button<ButtonProp>`
	align-items: center;
	background: ${({ theme, outboundColor }) =>
		outboundColor ? '#252252' : theme.colors.principal.pure};
	border: ${({ outboundColor }) => (outboundColor ? '0' : '1px')} solid
		${({ theme }) => theme.colors.principal.ceres};
	border-radius: 8px;
	color: ${({ theme, outboundColor }) =>
		outboundColor ? theme.colors.principal.pure : theme.colors.principal.vanth};
	cursor: pointer;
	display: flex;
	gap: 8px;
	justify-content: center;
	margin-top: 32px;
	padding: 15px;
	width: 100%;

	&:hover {
		opacity: 0.7;
	}

	&:disabled {
		cursor: default;
		opacity: 0.2;
		pointer-events: none;
	}
`;

export const DownloadLink = styled.a`
	align-items: center;
	background: ${({ theme }) => theme.colors.extra.saturn};
	border: none;
	border-radius: 8px;
	color: ${({ theme }) => theme.colors.principal.pure};
	cursor: pointer;
	display: flex;
	gap: 8px;
	justify-content: center;
	margin-top: 32px;
	padding: 15px;
	width: 100%;

	&:hover {
		opacity: 0.7;
	}
`;

export const SendEmail = styled.p`
	color: #646174;
	cursor: pointer;
	font-size: 14px;
	font-weight: 400;
	line-height: normal;
	margin-top: 16px;
	text-align: center;
`;

export const TransferDetail = styled.div`
	background: #f8f8f8;
	border-radius: 12px;
	margin-top: 32px;
	padding: 12px;
	width: 100%;
`;

export const TransferDetailContainer = styled.div`
	align-items: center;
	border-bottom: 1px solid #f2f2f2;
	display: flex;
	justify-content: space-between;
	padding: 8px 0;

	&:first-child {
		padding-top: 0;
	}

	&:last-child {
		border-bottom: none;
		padding: 8px 0 0;
	}
`;

export const TransferItem = styled.p`
	color: #636172;
	font-size: 16px;
	font-weight: 400;
	letter-spacing: -0.013px;
	line-height: normal;
`;

export const TransferData = styled.p`
	color: #140f33;
	font-size: 16px;
	font-weight: 400;
	letter-spacing: -0.013px;
	line-height: normal;
`;

export const DragAndDropContainer = styled.div`
	margin-top: 16px;
	width: 100%;
`;

export const FlexDiv = styled.div`
	display: flex;
	flex-direction: row;
	gap: 18px;
	width: 100%;
`;

export const DivSelect = styled.div`
	width: 100%;
`;

export const HintInputError = styled.p`
	color: ${({ theme }) => theme.colors.extra.sword};
	font-size: 12px;
	font-weight: 400;
	line-height: 12px;
	margin-top: 6px;
	text-align: left;
	width: 100%;
`;
